import React, { useState } from 'react'
import { Chip } from '@material-ui/core'
import AiChatPanel from './AiChatPanel'


// A "Chat with AI" chip and the chat panel for rendered HTML that is only
// being viewed. Fits in a section header, e.g. as a PaperWithHeader caption.
const ReadOnlyAiChat = ({ contentRef, chatKey }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Chip
        className='hide-print'
        label='✦ Chat with AI'
        color={open ? 'primary' : 'default'}
        // Keep the text selection, which the chat asks about
        onMouseDown={event => event.preventDefault()}
        onClick={() => setOpen(!open)}
        title='Chat with the AI assistant about this document'
      />
      {
        open &&
        <AiChatPanel contentRef={contentRef} chatKey={chatKey} onClose={() => setOpen(false)} />
      }
    </>
  )
}

export default ReadOnlyAiChat
